import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Services', href: '#services' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Reviews', href: '#testimonials' },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'nav-scrolled' : 'bg-background/80 backdrop-blur-md'
      }`}
    >
      <nav className="section-container flex items-center justify-between h-[52px]">
        {/* Logo */}
        <a href="/" className="flex flex-col no-underline">
          <span className="flex items-center gap-1.5">
            <div className="w-7 h-6 rounded-[6px] bg-apple-blue flex items-center justify-center">
              <span className="text-[8px] font-black text-white leading-none tracking-tight">Hx8</span>
            </div>
            <span className="font-bold text-[18px] tracking-tight text-foreground">
              Hire<span className="text-apple-blue">X8</span>
            </span>
          </span>
          <span className="text-[11px] text-muted-foreground mt-0.5">
            a concepts.io company
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-7">
          {navLinks.map(({ label, href }) => (
            <li key={label}>
              <a
                href={href}
                className="text-[14px] font-medium text-muted-foreground no-underline"
                style={{ transition: 'color 0.15s ease' }}
                onMouseEnter={e => e.target.style.color = 'hsl(0 0% 11%)'}
                onMouseLeave={e => e.target.style.color = ''}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-5">
          <a
            href="https://vibe.hirex8.com"
            className="btn-primary btn-sm"
          >
            Login
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 text-foreground rounded-lg"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background border-t border-border px-6 py-5 flex flex-col gap-4">
          {navLinks.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              className="text-[15px] font-medium text-foreground no-underline py-1"
              onClick={() => setMobileOpen(false)}
            >
              {label}
            </a>
          ))}
          <div className="pt-2 border-t border-border flex flex-col gap-3">
            <a
              href="https://vibe.hirex8.com"
              className="btn-primary text-center"
            >
              Login
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
